<div class="demo-page">

  <!-- Internal Banner -->
  <div class="internal-banner">
    <span class="internal-icon">🔒</span>
    <span>INTERNAL TEST PAGE</span>
  </div>

  <div class="demo-content">

    <!-- Header -->
    <div class="demo-header">
      <div>
        <h1>QR Code Landing Page – Demo & Test Links</h1>
        <p class="subtitle">Internal overview of all test URLs for development, QA and stakeholder demos</p>
      </div>
    </div>

    <!-- DE Top Products -->
    <section class="demo-section">
      <h2>🇩🇪 Germany</h2>
      <p class="section-desc">Sample URLs for key German product lines (SalesOrg 0500)</p>

      <div class="product-cards">
        <div *ngFor="let product of deProducts"
             class="product-card"
             [class.unavailable]="!product.available">

          <div class="product-card-header">
            <span class="product-name">{{ product.name }}</span>
            <span class="product-type">{{ product.type }}</span>
          </div>

          <div class="product-card-serial">
            <span class="serial-label">Serial number:</span>
            <code>{{ product.serialNumber }}</code>
          </div>

          <div class="product-card-actions" *ngIf="product.available; else placeholder">
            <a [href]="getProductUrl(product)" target="_blank" class="demo-link">
              <span>Open landing page</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#DA2501">
                <path d="M6 20.212 7.82 22 18 12 7.82 2 6 3.788 14.36 12z"/>
              </svg>
            </a>
            <code class="url-preview">{{ getProductUrl(product) }}</code>
          </div>

          <ng-template #placeholder>
            <div class="placeholder-notice">
                    ⚠️ No serial number configured
            </div>
          </ng-template>

        </div>
      </div>
    </section>

    <!-- Whitelabel -->
    <section class="demo-section">
      <h2>🏷️ Whitelabel Products</h2>
      <p class="section-desc">For products without a Viessmann serial number — static default page, no SAP lookup.</p>

      <div class="product-cards">
        <div class="product-card">
          <div class="product-card-header">
            <span class="product-name">Whitelabel Device</span>
            <span class="product-type">Generic / No serial number</span>
          </div>
          <div class="product-card-serial">
            <span class="serial-label">Route:</span>
            <code>/serialno/whitelabel</code>
          </div>
          <div class="product-card-actions">
            <a href="/serialno/whitelabel" target="_blank" class="demo-link">
              <span>Open whitelabel page</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#DA2501">
                <path d="M6 20.212 7.82 22 18 12 7.82 2 6 3.788 14.36 12z"/>
              </svg>
            </a>
            <code class="url-preview">/serialno/whitelabel</code>
          </div>
        </div>
      </div>
    </section>

    <!-- All Countries -->
    <section class="demo-section">
      <h2>🌍 All Countries / Markets</h2>
      <p class="section-desc">Test links for all supported sales organisations.</p>

      <table class="locales-table">
        <thead>
          <tr>
            <th>Country</th>
            <th>Language</th>
            <th>SalesOrg</th>
            <th>Product</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let locale of locales"
              [class.has-link]="!!locale.serialNumber"
              [class.no-link]="!locale.serialNumber">
            <td>
              <span class="flag-emoji">{{ getFlagEmoji(locale.country) }}</span>
              {{ locale.displayCountry }}
            </td>
            <td>{{ locale.displayLanguage }}</td>
            <td><code>{{ locale.salesOrganization }}</code></td>
            <td>{{ locale.productName || '–' }}</td>
            <td>
              <a *ngIf="locale.serialNumber; else noSerial"
                 [href]="getLocaleUrl(locale)"
                 target="_blank"
                 class="demo-link small">
              <span>Open</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#DA2501">
                  <path d="M6 20.212 7.82 22 18 12 7.82 2 6 3.788 14.36 12z"/>
                </svg>
              </a>
              <ng-template #noSerial>
                <span class="no-serial">No serial number</span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </section>


  </div>
</div>
